import { Component, computed, inject, input, output } from '@angular/core';

import { BaseItemComponent } from '../../common-items/BaseItem/base-item-form.component';
import { BaseItemProperties, DEFAULT_BASE_PROPERTIES } from '../../common-items/BaseItem/base-item-properties';

import { getPropsFrom } from '@lfw/roesberg.liveforms.core';
import { RepeaterItemFormComponent } from '../RepeaterItem/repeater-item-form.component';
import { LiveFormsTranslateLoaderService } from '../../../services/live-forms-translate-loader.service';

const REPEAT_SECTION_ITEM_NODE_NAME = 'RepeatSectionItem';

interface SectionEndItemProperties {
  style: string;
  parentSectionId: string;
  parentSectionAllowsCollapse: boolean;
}

@Component({
  selector: 'lfe-section-end-item-form',
  imports: [RepeaterItemFormComponent],
  templateUrl: './section-end-item-form.component.html',
  standalone: true,
  styleUrl: './section-end-item-form.component.css'
})
export class SectionEndItemFormComponent extends BaseItemComponent<SectionEndItemProperties> {
  protected readonly translateService = inject(LiveFormsTranslateLoaderService);
  protected readonly sectionEndLabel = this.translateService.instant('liveforms-editor.section-end-item.label')

  properties: BaseItemProperties & SectionEndItemProperties = {
    ...DEFAULT_BASE_PROPERTIES,
    style: '',
    parentSectionId: '',
    parentSectionAllowsCollapse: false
  };

  readonly sectionItemNodeName = input.required<string>();


  readonly addNewInstanceRequired = output<{ repeatItemId: string; anchorItemId: string }>();

  currentId = computed(() => this.properties.customId || this.properties.id);

  htmlId = computed(() => `section_end_${this.currentId()}`);

  isCollapsible = computed(() => this.properties.parentSectionAllowsCollapse);

  isParentSectionRepeat = computed(() => this.sectionItemNodeName() === REPEAT_SECTION_ITEM_NODE_NAME)

  extractLocalProperties(xml: Element): BaseItemProperties & SectionEndItemProperties {
    const props = getPropsFrom(xml);

    const customId = props['CustomID'];
    const id = props['ID'];
    const style = props['Style'] || '';
    const activationRule = props['ActivationRule'] || '';

    // These will need to be set by the parent form component based on the section context
    const parentSectionId = props['ParentSectionId'] || '';
    const parentSectionAllowsCollapse = props['ParentSectionAllowsCollapse'] === 'true';
    const isGenericRepeatItem = props['IsGenericRepeatItem'] === 'True';

    return {
      ...DEFAULT_BASE_PROPERTIES,
      id,
      customId,
      activationRule,
      style,
      parentSectionId,
      parentSectionAllowsCollapse,
      isGenericRepeatItem
    };
  }
}
